export default __webpack_public_path__ + "static/media/usa.10b5e9e0.svg";